import { z } from 'zod';
import type { Incident, Vehicle } from './model';

export const PlayerSchema = z.object({
  id: z.string(),
  email: z.string().email(),
  username: z.string().min(3).max(24),
  credits: z.number().int().min(0),
  controlCenterId: z.string().optional(),
  controlCenterLevel: z.number().int().min(1).max(5).default(1),
  createdAt: z.string(),
});
export type Player = z.infer<typeof PlayerSchema>;

export type CreditTransaction = {
  amount: number;
  reason: string;
  balance: number;
};

export const stationBuildCost = 12_000;

export const vehicleCosts: Record<Vehicle['kind'], number> = {
  KdoW: 7_000,
  'GW-L': 12_000,
  WLF: 16_000,
  TSF: 10_000,
  HLF: 18_000,
  LF: 14_000,
  TLF: 15_000,
  DLK: 22_000,
  RW: 17_000,
  ELW: 9_000,
  MTF: 5_000,
  RTW: 14_000,
  NEF: 11_000,
  KTW: 8_000,
  HvO: 4_000,
  'GW-San': 12_000,
  'SEG-Betreuung': 10_000,
  FuStW: 10_000,
  SEK: 25_000,
  MEK: 24_000,
  BePo: 18_000,
  DHuFü: 8_000,
  WaWe: 25_000,
  GKW: 16_000,
  MzGW: 14_000,
  'GW-Wasser': 13_000,
  RTB: 9_000,
  Bergrettung: 9_000,
  RTH: 30_000,
  ITH: 32_000,
};

export const controlCenterUpgradeCost = (level: number) => 10_000 + (level - 1) * 7_500;
export const stationUpgradeCost = (level: number) => 5_000 + (level - 1) * 4_000;

const incidentBaseReward: Record<Incident['type'], number> = {
  medizinisch: 1_000,
  vu: 1_500,
  brand: 1_800,
  polizei: 2_000,
  wasser: 1_700,
  berg: 1_800,
  unwetter: 1_400,
};

export function incidentReward(incident: Incident, assignedUnits: number) {
  const raw =
    incidentBaseReward[incident.type] +
    incident.escalation * 500 +
    Math.min(incident.actions.length, 6) * 150 +
    Math.min(assignedUnits, 12) * 50;
  return Math.max(1_000, Math.round(raw / 100) * 100);
}
